import { Platform } from "react-native";
import { NitroModules } from "react-native-nitro-modules";
import { rethrowNativeError } from "../nativeError";
import { StoreReview as unavailableStoreReview } from "./unavailable";
var hybrid;
function requestReview() {
  if (Platform.OS !== "ios" && Platform.OS !== "android") throw new Error("StoreReview requires a native build");
  hybrid !== null && hybrid !== void 0 ? hybrid : hybrid = NitroModules.createHybridObject("OneStoreReview");
  return hybrid.requestReview().catch(rethrowNativeError);
}
var nativeStoreReview = Object.freeze({
  requestReview
});
var StoreReview = Platform.OS === "ios" || Platform.OS === "android" ? nativeStoreReview : unavailableStoreReview;
export {
  StoreReview
};
//# sourceMappingURL=index.native.js.map
